import { z } from 'zod';
export const GenerateResponseSchema = z.object({
    success: z.boolean(),
    imageUrl: z.string().url().optional(),
    originalUrl: z.string().url().optional(),
    error: z.string().optional(),
    code: z.string().optional()
});
export const BillingCheckResponseSchema = z.object({
    success: z.boolean(),
    credits: z.number().nonnegative(),
    isPremium: z.boolean().optional(),
    plan: z.string().optional()
});
export const StripeCheckoutResponseSchema = z.object({
    success: z.boolean(),
    url: z.string().url(),
    sessionId: z.string().optional()
});
export const AnalyzeResponseSchema = z.object({
    success: z.boolean(),
    faces: z.array(z.any()).optional(),
    features: z.array(z.any()).optional(),
    error: z.string().optional()
});
export const TenantConfigResponseSchema = z.object({
    hostname: z.string(),
    themeProfile: z.any().optional(),
    islandVariants: z.any().optional()
});
